<template>
	<div v-if="uiVersion == 'v1'" class="bg-grey-1 rounded-xl text-white p-6">
		<div class="flex items-center gap-2 mb-6">
			<div class="grow text-1.5xl font-bold">Latest Gold Price</div>

			<div>
				<DropdownComp class="min-w-32" label="" triggerClass="bg-grey-2" dropdownClass="bg-grey-2"
					insideLabel="Kuantitas" :options="quantity" v-model="quantitySelected" />
			</div>

			<div>
				<DropdownComp class="min-w-32" label="" triggerClass="bg-grey-2" dropdownClass="bg-grey-2"
					insideLabel="Weight Unit" :options="units" v-model="unitSelected" />
			</div>
		</div>

		<div class="mb-3">
			<div class="text-xs">
				<table class="w-full text-center">
					<thead class="">
						<tr class="bg-grey-2 bg-clip-padding border-0 border-solid border-b-2 border-b-transparent">
							<th class="p-4">Currency</th>
							<th class="p-4">Buy Rate</th>
							<th class="p-4">Buy Price</th>
							<th class="p-4">Sell Rate</th>
							<th class="p-4">Sell Price</th>
						</tr>
					</thead>
					<tbody class="bg-grey-2">
						<tr v-if="exchangeRateApiStatus == 'error'" class="p-4">
							<td class="p-4" colspan="5" rowspan="4">
								<div>Gagal Memuat</div>
								<br>
								<div>
									<button class="btn c-btn-theme" @click="setExchangeRate()">Coba Lagi</button>
								</div>
							</td>
						</tr>

						<tr v-else-if="exchangeRateApiStatus == 'loading'" class="p-4">
							<td class="p-4" colspan="5" rowspan="4">
								<Loader size_prop="5rem" borderSize_prop="0.5rem"></Loader>
							</td>
						</tr>

						<tr v-else v-for="item in exchangeRate" class="p-4">
							<td class="p-4">
								<img class="w-5 "
									:src="require('@/assets/svg/flag-circle/flag-icon-' + Countries.find(country => country.currency === item.currency.toUpperCase()).threeLetterCode.toLowerCase() + '.svg')"
									alt="">
								&nbsp;
								<span>{{ item.currency }}</span>
							</td>
							<td class="p-4">{{ item.currency.toLowerCase() == 'idr' ? '' : findCurrencySymbol('idr') }}{{
								item.currency.toLowerCase() == 'idr' ? '' : item.buy.rate }}</td>
							<td class="p-4">{{ findCurrencySymbol(item.currency) }}{{ item.buy.price }}</td>
							<td class="p-4">{{ item.currency.toLowerCase() == 'idr' ? '' : findCurrencySymbol('idr') }}{{
								item.currency.toLowerCase() == 'idr' ? '' : item.sell.rate }}</td>
							<td class="p-4">{{ findCurrencySymbol(item.currency) }}{{ item.sell.price }}</td>
						</tr>

					</tbody>
				</table>
			</div>
		</div>

		<div class="text-xs">
			<div class="text-grey mb-1">JFXGOLD X Gold Price Update: {{ lastUpdateWidget }}</div>
			<div class="text-grey">Price per gram used is based on the 1g Pool contract</div>
		</div>
	</div>

	<div v-else-if="uiVersion == 'v2'" class="bg-grey-1 rounded-xl text-white p-6">

		<div class="grow text-sm font-bold mb-6">Harga Emas JFXGOLDX</div>

		<div class="flex items-center gap-2 mb-2">
			<div class="basis-1/2">
				<DropdownComp class="" label="" triggerClass="bg-grey-2" dropdownClass="bg-grey-2" insideLabel="Kuantitas"
					:options="quantity" v-model="quantitySelected" />
			</div>

			<div class="basis-1/2">
				<DropdownComp class="" label="" triggerClass="bg-grey-2" dropdownClass="bg-grey-2" insideLabel="Weight Unit"
					:options="units" v-model="unitSelected" />
			</div>
		</div>

		<div class="mb-3">
			<div class="text-xs">
				<table class="w-full text-center">
					<thead class="">
						<tr class="bg-grey-2 bg-clip-padding border-0 border-solid border-b-2 border-b-transparent">
							<th class="p-4">Currency</th>
							<th class="p-4">Buy Rate</th>
							<th class="p-4">Buy Price</th>
						</tr>
					</thead>
					<tbody class="bg-grey-2">
						<tr v-if="exchangeRateApiStatus == 'error'" class="p-4">
							<td class="p-4" colspan="5" rowspan="4">
								<div>Gagal Memuat</div>
								<br>
								<div>
									<button class="btn c-btn-theme" @click="setExchangeRate()">Coba Lagi</button>
								</div>
							</td>
						</tr>

						<tr v-else-if="exchangeRateApiStatus == 'loading'" class="p-4">
							<td class="p-4" colspan="5" rowspan="4">
								<Loader size_prop="5rem" borderSize_prop="0.5rem"></Loader>
							</td>
						</tr>

						<tr v-else v-for="item in exchangeRate" class="p-4">
							<td class="text-nowrap p-4">
								<img class="w-5 mr-3"
									:src="require('@/assets/svg/flag-circle/flag-icon-' + Countries.find(country => country.currency === item.currency.toUpperCase()).threeLetterCode.toLowerCase() + '.svg')"
									alt="">
								&nbsp;
								<span>{{ item.currency }}</span>
							</td>
							<td class="p-4">{{ findCurrencySymbol('idr') }}{{ item.buy.rate }}</td>
							<td class="p-4">{{ findCurrencySymbol(item.currency) }}{{ item.buy.price }}</td>
						</tr>

					</tbody>
				</table>
			</div>
		</div>

		<div class="text-xs">
			<div class="text-grey mb-1">JFXGOLD X Gold Price Update: {{ lastUpdateWidget }}</div>
			<div class="text-grey">Harga per gram yang digunakan adalah kontrak 1g Pool</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import { getWidget } from '../api/widget-mdaq'
import DropdownComp from './DropdownComp.vue'

import Utils from '@/utils/index.js'
import Countries from '@/internal/country.js'
import Loader from './Loader.vue'

export default {
	name: 'ExchangeRate',

	props: {
		uiVersion: {
			type: String,
			default: 'v1',
		},
	},

	components: {
		DropdownComp,
		Loader
	},

	data() {
		return {
			Countries: Countries,
			publicPath: process.env.BASE_URL,

			exchangeRateSequence: [
				'idr',
				'usd',
				'sgd',
				'myr'
			],

			quantity: [
				{
					label: '1',
					value: '1'
				},
				{
					label: '2',
					value: '2'
				},
				{
					label: '5',
					value: '5'
				},
				{
					label: '10',
					value: '10'
				},
				{
					label: '25',
					value: '25'
				},
			],

			units: [
				{
					label: 'gram (g)',
					value: 'gram'
				},
				{
					label: 'Troy Ounce (Toz) ',
					value: 'toz'
				},
			],

			quantitySelected: '1',
			unitSelected: 'gram',

			exchangeRate: [],

			stopPolling: false,
			exchangeRateApiStatus: 'idle',

			cancelTokenApiGetExchangeRate: null,

			lastUpdateWidget: null,
		}
	},

	watch: {
		quantitySelected() {
			this.cancelTokenApiGetExchangeRate()
			this.setExchangeRate()
		},

		unitSelected() {
			this.cancelTokenApiGetExchangeRate()
			this.setExchangeRate()
		}
	},

	created() {
		this.setExchangeRate()
	},

	beforeDestroy() {
		this.stopPolling = true
	},

	methods: {
		async setExchangeRate() {
			this.stopPolling = false
			this.exchangeRateApiStatus = 'loading'

			const { promise: promiseGetWidget, cancel } = getWidget({
				quantity: this.quantitySelected,
				unit: this.unitSelected
			})

			this.cancelTokenApiGetExchangeRate = cancel

			while (!this.stopPolling) {
				// for calculating wait duration
				const start = Date.now()

				try {
					const response = await promiseGetWidget()

					const exchangeRateTemp = []

					this.exchangeRateSequence.forEach(item => {
						const exchangeRateItemTemp = response.data.data.body[item.toUpperCase()]

						exchangeRateTemp.push({
							buy: {
								rate: Utils.currencyFormat(exchangeRateItemTemp.buy.rate, 'idr'),
								price: Utils.currencyFormat(exchangeRateItemTemp.buy.price, item)
							},
							sell: {
								rate: Utils.currencyFormat(exchangeRateItemTemp.sell.rate, 'idr'),
								price: Utils.currencyFormat(exchangeRateItemTemp.sell.price, item)
							},
							currency: item.toUpperCase()
						})
					})

					this.exchangeRate = exchangeRateTemp

					this.exchangeRateApiStatus = 'success'

					this.updateLastUpdateWidget()
				} catch (err) {
					console.log('err', err)

					// stop loop if not error by canceled
					if (!axios.isCancel(err)) {
						this.stopPolling = true
						this.exchangeRateApiStatus = 'error'
					}

					break
				}

				// wait 3000 ms - duration
				const duration = Date.now() - start
				const wait = 3000 - duration
				if (wait > 0) {
					await new Promise(res => setTimeout(res, wait))
				}
			}
		},

		updateLastUpdateWidget() {
			// format : 12 November 2025 pukul 05:00:00
			const temp = Date.now()
			const date = new Date(temp)
			const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
			const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
			const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

			this.lastUpdateWidget = date.toLocaleString('en-US', { month: 'long' }) + ' ' + date.getDate() + ', ' + date.getFullYear() + ' at ' + hours + ':' + minutes + ':' + seconds
		}
	}
}

</script>

<style scoped>
table {
	clip-path: inset(0 round 10px);
}
</style>